// export const statusIndexToText = {
//   "-1": "全部",
//   "0": "待锁定",
//   "1": "生效中", // 已锁定
//   "2": "已完成",
//   "3": "已取消",
// };

// export const statusTextToIndex = {
//   "全部": "-1",
//   "待锁定": "0",
//   "生效中": "1",
//   "已完成": "2", // 已锁定
//   "已取消": "3",
// };
export const statusIndexToText = { //10-待报价；20-已报价；30-已取消；40-已采购
  "0": "全部",
  "5": "待收货",
  "10": "待报价",
  "20": "已报价",
  "30": "已取消",
  "40": "已采购",
  "50": "已拒绝",
};
export const statusTextToIndex = Object.entries(statusIndexToText).reduce((acc, cur) => {
  const [v, k] = cur;
  return { ...acc, [k]: v };
  // ['0', '全部']
});

export const statusToButtons = {
  "5": "取消订单",
  "15": "取消订单",
  "20": "取消订单",
  "30": "确认收货",
  // "2": "再来一单",
  // "3": "再次购买"
};

export const statusToButtonsConfirmed = {
  0: "确认收货",
  100: "订单完结",
  // "2": "再来一单",
  // "3": "再次购买"
};

export const showNumber = 3;